import ContentStorage from '../../../tnew/content/ContentStorage';


const COMPONENT_KEY = '32a0f2f8-6d0e-4f70-bb20-c03b3e9d24ad';

const get = name => ContentStorage.get(COMPONENT_KEY, name);


class FormFieldsComponent {
  static get requiredFieldValidationMessage() {
    return get('RequiredFieldValidationMessage');
  }

  static get contributionMinimumValidationMessage() {
    return get('ContributionMinimumValidationMessage');
  }

  static get decimalValidationMessage() {
    return get('DecimalValidationMessage');
  }
}


export default FormFieldsComponent;



// WEBPACK FOOTER //
// ./src/events/detail/components/FormFieldsComponent.js